import { EDeleteAllNotificationActionTypes, TDeleteAllNotificationsSucceed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const deleteAllSucceed: () => TDeleteAllNotificationsSucceed =
  actionGenerator<EDeleteAllNotificationActionTypes.Succeed>(EDeleteAllNotificationActionTypes.Succeed);
